export const API = 'https://api.lebelanguagebeta.com'
